import { Box, Button, styled, Modal, Typography, IconButton, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import CloseIcon from '@mui/icons-material/Close';
import EmergencyInfo from './EmergencyInfo';
import EmergencyStart from './EmergencyStart';
import EmergencyInfoTable from './EmergencyInfoTable';
import { api } from '../../../api';
import { useNavigate } from 'react-router-dom';
import { Download } from '@mui/icons-material';

const EmergencyStructurePlan = () => {
  const navigate = useNavigate();
  const [isShowConfirmModal, setIsShowConfirmModal] = useState<'start' | 'end' | null>(null);
  const [selectedEmergencyRoleId, setSelectedEmergencyRoleId] = useState<string | number | null>(
    null
  );
  const [isCounting, setIsCounting] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const handleImportCSVFile = async (event: any) => {
    if (isLoading) {
      return;
    }
    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    setIsLoading(true);
    api
      .post(`/emergency/import`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(() => {
        navigate(0);
      })
      .finally(() => setIsLoading(false));
  };
  const handleExportCSVFile = () => {
    if (isExportLoading) {
      return;
    }
    setIsExportLoading(true)
    api
      .get(`/emergency/export`, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'emergency_export_data.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => setIsExportLoading(false));
  };

  const getEmergencyStatus = () => {
    api.get(`/emergency/status`).then((res) => {
      const { data } = res;
      setIsCounting(data.is_counting);
    });
  };

  const startCounting = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    api
      .post(`/emergency/start`, {})
      .then(() => {
        getEmergencyStatus();
      })
      .finally(() => setIsLoading(false));
  };

  const endCounting = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    api
      .post(`/emergency/end`, {}, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'emergency_data.xlsx');
        document.body.appendChild(link);
        link.click();

        getEmergencyStatus();
      })
      .finally(() => setIsLoading(false));
  };

  const handleOnClickConfirm = () => {
    if (isShowConfirmModal === 'start') {
      startCounting();
    } else {
      endCounting();
    }
    setIsShowConfirmModal(null);
  };

  const handleExportPersonInfoCSVFile = (emergencyRoleId: string | number) => {
    if (emergencyRoleId != null) {
      const searchParams = new URLSearchParams();
      // if (isCounting) {
      searchParams.set('has_area', `${true}`);
      // }
      api
        .get(`/emergency/role/${emergencyRoleId}/person/export`, {
          params: searchParams,
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'emergency_structure_plan_person_export_data.xlsx');
          document.body.appendChild(link);
          link.click();
        });
    }
  };

  useEffect(() => {
    getEmergencyStatus();
  }, []);

  function downloadFile(url: any, fileName: any) {
    fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
      .then((res) => res.blob())
      .then((res) => {
        const aElement = document.createElement('a');
        aElement.setAttribute('download', fileName);
        const href = URL.createObjectURL(res);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
      });
  }

  return (
    <>
      <Container>
        <PageHeader text="แผนโครงสร้างฉุกเฉิน" />
        <Box display="flex" justifyContent="end">
          {!isCounting ? (
            <>
              {/* <Button variant="outlined" sx={{ marginX: '4px' }} onClick={handleExportCSVFile}>
                <Icon></Icon>
              </Button> */}
              <IconButton
                id="long-button"
                onClick={() =>
                  downloadFile(
                    '/asset/template_รายชื่อตามโครงสร้างเหตุฉุกเฉินรวม.csv',
                    'template_รายชื่อตามโครงสร้างเหตุฉุกเฉินรวม.csv'
                  )
                }
              >
                <Download />
              </IconButton>
              <Tooltip title={`ไม่รวม "อื่นๆ"`}>
                <Button variant="outlined" sx={{ marginX: '4px' }} onClick={handleExportCSVFile} disabled={isExportLoading}>
                  Export
                </Button>
              </Tooltip>
              {/* <Button variant="outlined" sx={{ marginX: '4px' }}>
                Import
              </Button> */}
              <Tooltip title={`ไม่รวม "อื่นๆ"`}>
                <Button variant="outlined" sx={{ marginX: '4px' }} component="label">
                  Import
                  <input
                    hidden
                    accept=".csv"
                    type="file"
                    onChange={(e) => handleImportCSVFile(e)}
                  />
                </Button>
              </Tooltip>
              <Button
                variant="outlined"
                sx={{ marginX: '4px' }}
                onClick={() => setIsShowConfirmModal('start')}
              >
                นับจำนวน
              </Button>
            </>
          ) : (
            <Button
              variant="outlined"
              sx={{ marginX: '4px' }}
              color="error"
              onClick={() => setIsShowConfirmModal('end')}
            >
              สื้นสุดการนับจำนวน
            </Button>
          )}
        </Box>
        {isCounting ? (
          <EmergencyStart
            handleOnClickInfo={(roleId: string | number) => setSelectedEmergencyRoleId(roleId)}
            handleOnClickExport={(roleId: string | number) => handleExportPersonInfoCSVFile(roleId)}
          />
        ) : (
          <EmergencyInfo
            handleOnClickInfo={(roleId: string | number) => setSelectedEmergencyRoleId(roleId)}
            handleOnClickExport={(roleId: string | number) => handleExportPersonInfoCSVFile(roleId)}
          />
        )}
      </Container>
      <Modal
        open={selectedEmergencyRoleId != null}
        onClose={() => setSelectedEmergencyRoleId(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer>
          <Box display="flex" justifyContent="space-between">
            <PageHeader text="รายชื่อบุคคล" />
            <CloseIcon onClick={() => setSelectedEmergencyRoleId(null)} />
          </Box>
          <EmergencyInfoTable emergencyRoleId={selectedEmergencyRoleId} isCounting={isCounting} />
        </ModalContainer>
      </Modal>
      <Modal
        open={isShowConfirmModal != null}
        onClose={() => setIsShowConfirmModal(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer sx={{ maxWidth: 500 }}>
          <Box display="flex" justifyContent="space-between">
            <PageHeader
              text={
                isShowConfirmModal === 'start'
                  ? 'ยืนยันการเริ่มนับจำนวน'
                  : 'ยืนยันสิ้นสุดการนับจำนวน'
              }
            />
            <CloseIcon onClick={() => setIsShowConfirmModal(null)} />
          </Box>
          <Box my={3}>
            <Typography>
              {isShowConfirmModal === 'start'
                ? 'ยืนยันการเริ่มนับจำนวนใช่หรือไม่ ?'
                : 'ยืนยันสิ้นสุดการนับจำนวนใช่หรือไม่ ?'}
            </Typography>
          </Box>
          <Box display="flex">
            <Button
              variant="contained"
              color="inherit"
              fullWidth
              onClick={() => setIsShowConfirmModal(null)}
            >
              ยกเลิก
            </Button>
            &nbsp;
            <Button variant="contained" fullWidth onClick={() => handleOnClickConfirm()}>
              ยืนยัน
            </Button>
          </Box>
        </ModalContainer>
      </Modal>
    </>
  );
};

export default EmergencyStructurePlan;

const Container = styled('div')`
  padding: 16px;
`;

const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
  borderRadius: 16,
  padding: 16,
  width: '70%'
}));
